import type { User } from "@/store/userStore.ts";
import { UserRound } from "lucide-react";

type ProfilePictureProps = {
    user?: User | null;
    data?: string;
    className?: string;
};

export function ProfilePicture(props: ProfilePictureProps) {
    return (
        <div className={props.className}>
            {props.user?.personalInformation.avatarBase64 || props.data ? (
                <img
                    alt="Profile Picture"
                    className="rounded-full aspect-square h-full object-cover"
                    src={
                        props.data
                            ? props.data
                            : props.user?.personalInformation.avatarBase64
                    }
                />
            ) : (
                <div className="flex h-full aspect-square justify-center items-center bg-tertiary rounded-full">
                    <UserRound className="w-[60%] h-[60%]" />
                </div>
            )}
        </div>
    );
}
